import React from 'react';

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
	super(props);
	this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
	// Update state so the next render will show the fallback UI.
	return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
	// 1. Log the error to the console for local debugging
	console.error("Caught by Error Boundary:", error, errorInfo);

	// 2. Explicitly send the error to New Relic
	if (typeof window.newrelic !== 'undefined') {
		window.newrelic.noticeError(error, errorInfo);
	}
  }

  render() {
	if (this.state.hasError) {
	  // You can render any custom fallback UI here instead of a blank screen
	  return (
		<div style={{ padding: '20px', textAlign: 'center' }}>
			<h1>Sorry, something went wrong.</h1>
			<p>Our team has been notified.</p>
		</div>
	  );
	}

	return this.props.children; 
  }
}

export default GlobalErrorBoundary;